<template>
    <section class="attestation_txt">
		<van-popup v-model="isExplain" round position="bottom" :style="{ height: '98%' }" class="login_model" :close-on-click-overlay="false">
			<section>
				<van-nav-bar title="隐私协议"  @click-left="lookFn('login')" />
				<div class="close_icon" @click="closeModel">
					<van-icon name="cross" />
				</div>
				<div class="content">
					<!-- <h2>信息授权告知书</h2> -->
					<p>本人 <i></i>（身份证号码：<i></i> ）授权【闪电展业】app在向本人提供产品或服务过程中，在本人的授权范围内，收集、处理、使用、共享本人的资料及个人信息，包括但不限于本人的姓名、身份证号、手机号码等个人信息。</p>
					<p>1、本人同意贵司将上述信息用于本人所明确授权的范围和用途。</p>
					<p>2、本人同意贵司将上述信息提供给第三方服务机构 ，用于对本人的身份核验，以验证本人所提供的信息的真实性。 </p>
					<p>3、本人同意第三方服务机构将本人的个人信息用于与外部数据库的比对工作，以获得验证结果。 </p>
					<p>4、本人知悉并理解，即便在贵司以及第三方服务机构具备足够的数据安全能力并提供足够的安全保护水平的前提下，本人的信息仍可能存在不可控的风险。</p>
					<p>5、本人声明，已充分理解并同意上述相关授权内容，本人自愿签署本授权书，并清晰知晓因此可能产生的一切法律后果。 </p>
					<div class="name">授权人：</div>
					<div class="time">年<i></i>月<i></i>日</div>
				</div>
			</section>
		</van-popup>
	</section>
</template>

<script>

export default {
    name: "login",
	props: {
		isExplain: Boolean,
	},
	components: {
	},

    data() {
		//type: login, yinsi, yonghu, kehu
        return {
			
		};
		
    },
    created() {
	},
    methods: {
		closeModel() {
			this.$emit('closeModel')
		},
	},
};
</script>

<style lang="scss">
.attestation_txt {
	.login_model {
		// position: relative;
		.close_icon {
			position: fixed;
			left: 0;
    		z-index: 20;
			height: 59px;
			line-height: 59px;
			color: #7D8290;
			font-size: 22px;
			i {
				padding: 20px 18px;
				padding-bottom: 0;
			}
		}
		.login_icon {
			text-align: center;
			padding-top: 133px;
			padding-bottom: 20px;
			img {
				width: 96px;
			}
		}
		.form {
			padding-bottom: 20px;
			padding: 0 29px;
			.van-field {
				border-bottom: 1Px solid #f6f6f6;
			}
			.van-field__control {
				font-size: 16px;
				color: #2B2F3A;
			}
			.van-cell {
				padding: 0;
				height: 68px;
				line-height: 68px;
				padding-top: 10px;
				
			}
			.van-cell::after {
				// border-bottom: 1Px solid #f6f6f6
				// top: 0;
				bottom: -10PX;
			}
			.code {
				color: #a2a6ae;
				font-size: 16px;
			}
			.code_a {
				color: #3A5EEC;
			}
		}
		.desc {
			padding: 0 29px;
			padding-left: 50px;
			position: relative;
			margin-top: 18px;
			div	{
				position: absolute;
				top: 0;
				left: 0;
				width: 45px;
				height: 30px;
			}
			img {
				position: absolute;
				top: 2px;
				left: 30px;
				width: 14px;
			}
			p {
				font-size: 13px;
				color: #A2A6AE;
				span {
					color: #2B2F3A;
				}
			}
		}
		.bottom_btn{
			padding: 0 30px;
			padding-top: 74px;
			.van-button--primary {
				width: 100%;
				height: 42px;
				border-radius: 4px;
				border: 0;
				font-size: 15px;
				font-weight: bold;
				color: #FFFFFF;
			}
		}
		.explain {
			color: #A2A6AE;
			font-size: 13px;
			padding-top: 14px;
			text-align: center;
		}
		.van-nav-bar__title {
			color: #2B2F3A;
			font-size: 17px;
		}
		.van-nav-bar__content {
			height: 59px;
		}
		.van-nav-bar__left {
			.van-icon-arrow-left {
				color: #979797;
				font-size: 22px;
			}
		}
		.van-count-down {
			display: inline-block;
			color: #A2A6AE;
			font-size: 16px;
		}
		.fix_top {
			// position: absolute;
			// top: 0;
			// left: 0;
			// width: 100%;
			// z-index: 99;
		}
	}
	.content {
			position: relative;
			z-index: 2;
			padding: 40px 20px;
			padding-top: 20px;
			p {
				text-indent: 28px;
				font-size: 14px;
				line-height: 26px;
				i {
					display: inline-block;
					width: 40px;
					height: 20px;
					border-bottom: 1px solid #000;
				}
			}
			.name {
				padding-top: 30px;
				font-size: 14px;
				text-align: center;
			}
			.time {
				padding-top: 10px;
				font-size: 14px;
				text-align: center;
				padding-left: 60px;

				i {
					display: inline-block;
					width: 20px;
				}
			}
		}
}
</style>


// WEBPACK FOOTER //
// src/views/components/AttestationTxt.vue